import { Inject, Injectable, InjectionToken } from '@angular/core';

import { NEVER, Observable, filter, fromEvent, map } from 'rxjs';

import { hasOwnProp } from '../helpers/object-utils';

@Injectable({
  providedIn: 'root'
})
export class TabSyncService {
  private readonly channel = this.createChannel();

  constructor(@Inject(TAB_SYNC_CHANNEL) private readonly channelName: string) {}

  public postMessage<T = unknown>(data: T): void {
    this.channel?.postMessage(data);
  }

  public onMessage$<T>(...params: (keyof T)[]): Observable<T> {
    return this.channel
      ? fromEvent<MessageEvent<T>>(this.channel, 'message').pipe(
          map(({ data }) => data),
          filter<T>(data => !params || params.some(p => hasOwnProp(data, p)))
        )
      : NEVER;
  }

  private createChannel(): BroadcastChannel {
    try {
      return new BroadcastChannel(this.channelName);
    } catch (e) {
      return null;
    }
  }
}

export const TAB_SYNC_CHANNEL = new InjectionToken<string>('shrd.utc.tabSyncChannel', { factory: () => 'hilti-hdms' });
